import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import MTravelLogo from '/logo_full.svg'

import { Player } from '@lottiefiles/react-lottie-player'
import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { setSettingForApp } from 'entities/user/module/app-settings'
import userStore from 'entities/user/module/user-store'

import TicketImage from 'shared/images/certificates.webp'
import CelebrationJson from 'shared/json/celebration.json'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const CertificateScreen = observer(() => {
  const { t } = useTranslation()

  const [isBannerShowed, setShowed] = useState<boolean>(
    Boolean(userStore.getClientStateString('bannerLoaded')),
  )

  useEffect(() => {
    setShowed(Boolean(userStore.getClientStateString('bannerLoaded')))
  }, [userStore.client_state])

  const onClick = () => setShowed(!isBannerShowed)

  useEffect(() => {
    const isShowed = Boolean(userStore.getClientStateString('bannerLoaded'))

    if (!isShowed && userStore?.account?.has_certificate)
      void setSettingForApp({ key: 'bannerLoaded', value: 'true' })
  })

  if (
    userStore?.account &&
    userStore?.account?.has_certificate &&
    !isBannerShowed
  ) {
    return (
      <div className={clsx('safe-area-top-padding', s.container)}>
        <ImageLazy
          alt="logo"
          src={MTravelLogo}
          className={s.logo}
        />

        <div className={s.info}>
          {/* <p className={s.subtitle}>{t('certificate.hello')}</p> */}
          <p className={s.title}>
            {t('certificate.congratulations', { sum: '10 000' })}
          </p>
        </div>

        <div className={s.celebration}>
          <Player
            loop
            autoplay
            renderer={'svg'}
            src={CelebrationJson}
          />
        </div>

        <ImageLazy
          src={TicketImage}
          alt={'ticket'}
          className={s.image}
        />

        <Button
          borderRadius="md"
          className={s.button}
          onClick={onClick}
        >
          {t('certificate.super')}
        </Button>
      </div>
    )
  }

  return null
})
